export const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzBSaDcumBJR5pvRRZmUYOZuDyut53b-v-iRhYOpzVy-9zjZuPwnPEAMTGIz4NY6eJF/exec';

const BOT_SIGNATURES = [
  ['gptbot', 'GPTBot (OpenAI)', 'ai'],
  ['chatgpt-user', 'ChatGPT User', 'ai'],
  ['oai-searchbot', 'OAI SearchBot', 'ai'],
  ['claudebot', 'ClaudeBot (Anthropic)', 'ai'],
  ['claude-web', 'Claude Web', 'ai'],
  ['anthropic-ai', 'Anthropic AI', 'ai'],
  ['perplexitybot', 'PerplexityBot', 'ai'],
  ['youbot', 'YouBot (You.com)', 'ai'],
  ['cohere-ai', 'Cohere AI', 'ai'],
  ['diffbot', 'Diffbot', 'ai'],
  ['bytespider', 'ByteSpider (ByteDance)', 'ai'],
  ['amazonbot', 'AmazonBot', 'ai'],
  ['applebot', 'AppleBot', 'ai'],
  ['facebookbot', 'FacebookBot', 'ai'],
  ['meta-externalagent', 'Meta External Agent', 'ai'],
  ['googlebot', 'Googlebot', 'seo'],
  ['bingbot', 'Bingbot', 'seo'],
  ['slurp', 'Yahoo Slurp', 'seo'],
  ['duckduckbot', 'DuckDuckBot', 'seo'],
  ['baiduspider', 'Baiduspider', 'seo'],
  ['yandexbot', 'YandexBot', 'seo'],
  ['petalbot', 'PetalBot (Huawei)', 'seo'],
  ['semrushbot', 'SEMrushBot', 'seo'],
  ['ahrefsbot', 'AhrefsBot', 'seo'],
  ['mj12bot', 'MajesticBot', 'seo'],
  ['dotbot', 'DotBot (Moz)', 'seo'],
  ['rogerbot', 'Rogerbot (Moz)', 'seo'],
  ['exabot', 'ExaBot', 'seo'],
  ['gigabot', 'GigaBot', 'seo'],
  ['seznambot', 'SeznamBot', 'seo'],
  ['sogou', 'SogouBot', 'seo'],
  ['360spider', '360Spider', 'seo'],
  ['serpstatbot', 'SerpstatBot', 'seo'],
  ['dataforseobot', 'DataForSEOBot', 'seo'],
  ['sitebulb', 'Sitebulb', 'seo'],
  ['screaming frog', 'Screaming Frog', 'seo'],
  ['facebot', 'Facebot (Facebook)', 'social'],
  ['ia_archiver', 'Flipboard', 'social'],
  ['twitterbot', 'TwitterBot', 'social'],
  ['linkedinbot', 'LinkedInBot', 'social'],
  ['whatsapp', 'WhatsApp', 'social'],
  ['telegrambot', 'TelegramBot', 'social'],
  ['pinterestbot', 'PinterestBot', 'social'],
  ['slackbot', 'Slackbot', 'social'],
  ['discordbot', 'DiscordBot', 'social'],
  ['nessus', 'Nessus Scanner', 'security'],
  ['nikto', 'Nikto Scanner', 'security'],
  ['masscan', 'Masscan', 'security'],
  ['zgrab', 'ZGrab', 'security'],
  ['shodan', 'Shodan', 'security'],
  ['censys', 'Censys', 'security'],
  ['ia_archiver', 'Internet Archive', 'archive'],
  ['archive.org_bot', 'Archive.org Bot', 'archive'],
  ['headlesschrome', 'Headless Chrome', 'headless'],
  ['phantomjs', 'PhantomJS', 'headless'],
  ['prerender', 'Prerender', 'headless'],
  ['puppeteer', 'Puppeteer', 'headless'],
  ['playwright', 'Playwright', 'headless'],
  ['selenium', 'Selenium', 'headless'],
];

export function analyticsUrl(params) {
  return `${SCRIPT_URL}?${new URLSearchParams(params).toString()}`;
}

export function isLocalAnalyticsHost() {
  if (typeof window === 'undefined') return false;
  return ['localhost', '127.0.0.1', '0.0.0.0', '::1'].includes(window.location.hostname);
}

export function shouldTrackAnalytics() {
  return process.env.REACT_APP_ENABLE_LOCAL_ANALYTICS === 'true' || !isLocalAnalyticsHost();
}

export function track(params, options) {
  if (!shouldTrackAnalytics()) return Promise.resolve(null);
  return fetch(analyticsUrl(params), options).catch(() => {});
}

export function getFilename(url) {
  const raw = String(url || '').split('/').pop().split('?')[0];
  return decodeURIComponent(raw);
}

export function detectBot() {
  const ua = (navigator.userAgent || '').toLowerCase();

  if (navigator.webdriver === true) {
    return { name: 'WebDriver (automatisation)', category: 'headless', ua: navigator.userAgent };
  }

  if (window.innerWidth === 0 || window.innerHeight === 0) {
    return { name: 'Headless (viewport nul)', category: 'headless', ua: navigator.userAgent };
  }

  if (!navigator.languages || navigator.languages.length === 0) {
    return { name: 'Bot (no language)', category: 'other', ua: navigator.userAgent };
  }

  for (const [kw, name, category] of BOT_SIGNATURES) {
    if (ua.includes(kw)) return { name, category, ua: navigator.userAgent };
  }

  return null;
}
